<template>
  <section v-if="!isEmpty('user')" class="stories container-mobile">
    <div class="tabs">
      <div
        v-for="(tab, key) in tabs"
        @click="toggleTabs(tabs, key, updateTab(key))"
        class="tabs-item"
        :key="key"
        :class="{ 'tabs-current': tab.selected }"
      >
        {{ tab.text }}
      </div>
    </div>

    <div v-if="!showForm" class="add-story-opener">
      <button @click="showForm = true" class="add-story-button">
        {{ $t("stories.writeStory") }}
      </button>
    </div>
    <div v-else class="add-story-form info-block" ref="storyForm">
      <div class="form-group">
        <label for="title" class="label title-label"
          >{{ $t("stories.nameStory") }}:</label
        >
        <input
          type="text"
          v-model="title"
          name="title"
          v-validate.persist="'required'"
          :maxlength="140"
          class="input"
          :class="{ 'field-error': errors.has('title') }"
        />
        <label for="title" class="v-error label-tip">{{
          errors.first("title")
        }}</label>
      </div>

      <div class="form-group textarea-group">
        <label for="text" class="label text-label"
          >{{ $t("stories.textStory") }}:</label
        >
        <textarea
          v-model="text"
          name="text"
          v-validate.persist="'required'"
          wrap="hard"
          class="textarea"
          :class="{ 'field-error': errors.has('text') }"
        ></textarea>
        <label for="text" class="v-error label-tip">{{
          errors.first("text")
        }}</label>
      </div>

      <div class="buttons-row">
        <button @click="cancelEdit" class="button-secondary">
          {{ $t("stories.cancel") }}
        </button>
        <button @click="create" v-if="!btnLoader" class="button">
          {{ $t("stories.publish") }}
        </button>
        <button v-if="btnLoader" class="button button-loader"></button>
      </div>
    </div>

    <div v-if="pageLoader" class="page-loader">{{ $t("loading.loading") }}</div>

    <div v-else>
      <div
        class="stories-block"
        v-for="(storiesBlock, type) in stories"
        v-show="tabs[type].selected"
        :key="type"
      >
        <div class="stories-list">
          <p v-if="storiesIsEmpty(type, 'stories')" class="no-content">
            {{ $t("stories.thereStoriesSectionYet") }}
          </p>
          <div
            v-for="(story, index) in storiesBlock.data"
            :ref="type + index"
            class="info-item info-block"
            :key="story.id"
          >
            <!-- <storyContext
                            v-if="user.id == story.owner.id"
                            :id="story.id"
                            class="stories-context-desktop"
                        ></storyContext> -->
            <div class="info-item-body">
              <div class="stories-title">{{ story.title }}</div>
              <storyText :text="story.text" :index="index"></storyText>
            </div>
            <div class="info-item-footer">
              <div class="stories-votes">
                <storyVote
                  v-if="user.id != story.owner.id"
                  :up="true"
                  :id="story.id"
                  :active="story.liked"
                ></storyVote>
                <div
                  class="stories-rating"
                  :class="{
                    good: story.rating > 0,
                    bad: story.rating < 0,
                    neutral: story.rating == 0,
                    'not-my': user.id != story.owner.id,
                  }"
                >
                  {{ story.rating }}
                </div>
                <storyVote
                  v-if="user.id != story.owner.id"
                  :up="false"
                  :id="story.id"
                  :active="story.disliked"
                ></storyVote>
              </div>
              <div
                v-if="
                  user.id == story.owner.id &&
                  story.edit_end + Math.floor(timeDelta / 1000) > remain &&
                  !initIsEmpty('init')
                "
                class="stories-edit"
              >
                <span @click="startEdit(story)" class="stories-edit-link">
                  {{ $t("stories.edit") }}</span
                >
                <br />
                <span class="stories-edit-remain">
                  {{
                    getRemainHM(
                      story.edit_end + Math.floor(timeDelta / 1000) - remain,
                      true
                    )
                  }}
                </span>
              </div>
              <storyContext
                v-if="user.id == story.owner.id"
                :story="story"
                @edit="startEdit(story)"
                class="stories-context-wrapper"
              ></storyContext>
              <div class="info-right">
                <redirectButton
                  pathname="profile"
                  :params="{ id: story.owner.id }"
                  :html="story.owner.name"
                  class="info-author"
                ></redirectButton>
                <div class="info-time">
                  {{ getVerbalDate(story.created_at * 1000) }}
                </div>
                <div
                  :style="{
                    'background-image': story.owner.avatar
                      ? 'url(' + story.owner.avatar + ')'
                      : '',
                  }"
                  class="info-avatar"
                  :class="{ 'no-avatar': !story.owner.avatar }"
                ></div>
              </div>
            </div>
          </div>

          <div v-if="moreLoader" class="buttons-row">
            <button class="button-loader"></button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section v-else>
    <div class="no-auth">
      {{ $t("auth.noAuth") }}
      <router-link class="link" tag="a" :to="{ name: 'home' }">{{
        $t("auth.noAuthLink")
      }}</router-link>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import redirectButton from "@/components/Buttons/Redirect";
import storyContext from "@/components/Blocks/StoryContext";
import storyText from "@/components/Blocks/StoryText";
import storyVote from "@/components/Blocks/StoryVote";
import { formatDateTime } from "@/mixins/formatDateTime";
import { toggleTabs } from "@/mixins/toggleTabs";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
  name: "Stories",
  props: {
    i18n: Object,
  },
  components: {
    redirectButton,
    storyContext,
    storyText,
    storyVote,
  },
  mixins: [localizeValidation, formatDateTime, toggleTabs, observeListEnd],
  data() {
    return {
      title: "",
      text: "",
      nonFieldErrors: [],
      btnLoader: false,
      remain: 0,
      editId: null,
      storyTop: null,
      tabs: {
        my: {
          text: this.$t("stories.myStories"),
          selected: true,
          moreIndex: 0,
          observer: null,
        },
        best: {
          text: this.$t("stories.bestStories"),
          selected: false,
          moreIndex: 0,
          observer: null,
        },
        new: {
          text: this.$t("stories.newStories"),
          selected: false,
          moreIndex: 0,
          observer: null,
        },
      },
      showForm: false,
      pageLoader: true,
      moreLoader: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      isEmpty: "user/isEmpty",
      storiesIsEmpty: "stories/isEmpty",
      myStories: "stories/fetchMy",
      myStoriesNext: "stories/fetchMyNext",
      newStories: "stories/fetchNew",
      newStoriesNext: "stories/fetchNewNext",
      bestStories: "stories/fetchBest",
      bestStoriesNext: "stories/fetchBestNext",
      storiesErrors: "stories/errors",
      initIsEmpty: "init/isEmpty",
      timeDelta: "init/fetchTimeDelta",
    }),
    stories() {
      return {
        my: {
          loader: true,
          data: this.myStories,
          next: this.myStoriesNext,
        },
        new: {
          loader: true,
          data: this.newStories,
          next: this.newStoriesNext,
        },
        best: {
          loader: true,
          data: this.bestStories,
          next: this.bestStoriesNext,
        },
      };
    },
  },
  created() {
    this.localizeValidation();
    this.getStories();
    this.remain = Math.floor(+new Date() / 1000);
    setInterval(() => {
      this.remain = Math.floor(+new Date() / 1000);
    }, 1000);
  },
  methods: {
    getStories() {
      let arr = [];
      for (let key in this.stories) {
        let self = this;
        this.tabs[key].observer = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting === true && self.tabs[key].selected) {
              self.showMore(key);
            }
          },
          { threshold: [0] }
        );

        arr.push(
          this.$store.dispatch("stories/get", key).then(() => {
            this.updateMoreIndex(key);
            this.observeListEnd(key, this.tabs);
          })
        );
      }
      Promise.all(arr)
        .then(() => {
          this.pageLoader = false;
        })
        .catch(() => {
          this.pageLoader = false;
        });
    },
    updateMoreIndex(tab) {
      this.tabs[tab].moreIndex = this.stories[tab].data.length - 2;
    },
    showMore(type) {
      if (this.stories[type].next) {
        this.moreLoader = true;
        this.$store
          .dispatch("stories/getNext", type)
          .then(() => {
            this.observeListEnd(type, this.tabs, true, true);
            this.moreLoader = false;
          })
          .catch(() => {
            this.moreLoader = false;
          });
      } else {
        this.observeListEnd(type, this.tabs, true);
      }
    },
    create() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.btnLoader = true;
          let action = this.editId ? "stories/update" : "stories/create";
          let data = this.editId
            ? {
                id: this.editId,
                data: {
                  title: this.title,
                  text: this.text,
                },
              }
            : {
                title: this.title,
                text: this.text,
              };
          this.$store
            .dispatch(action, data)
            .then(() => {
              this.text = "";
              this.title = "";
              this.editId = null;
              this.errors.clear();
              this.$validator.reset();
              if (this.storyTop) {
                window.scrollTo({
                  top: this.storyTop,
                  behavior: "smooth",
                });
              }
              this.storyTop = null;
              this.btnLoader = false;
              this.showForm = false;
            })
            .catch((err) => {
              for (let key in this.storiesErrors) {
                this.errors.add({
                  field: key,
                  msg: this.storiesErrors[key][0],
                });
              }
              this.btnLoader = false;
            });
        }
      });
    },
    startEdit(story) {
      let promise = new Promise((resolve, reject) => {
        if (this.title || this.text) {
          this.$modal.show("dialog", {
            title: this.$t("threads.warning"),
            text: this.$t("stories.youHaveHistoryLost"),
            buttons: [
              {
                title: this.$t("stories.continue"),
                handler: () => {
                  this.$modal.hide("dialog");
                  resolve();
                },
              },
              {
                title: this.$t("stories.cancel"),
              },
            ],
          });
        } else {
          resolve();
        }
      });

      promise.then((result) => {
        this.title = story.title;
        this.text = story.text;
        this.editId = story.id;
        let form = this.$refs.storyForm;
        this.storyTop =
          form && form.offsetHeight
            ? pageYOffset - form.offsetHeight
            : pageYOffset;
        this.showForm = true;
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },
    cancelEdit() {
      this.showForm = false;
      this.text = "";
      this.title = "";
      this.errors.clear();
      this.$validator.reset();
      if (this.editId) {
        window.scrollTo({
          top: this.storyTop,
          behavior: "smooth",
        });
        this.editId = null;
      }
    },
    updateTab(key) {
      this.updateText();
    },
    updateText() {
      this.$store.dispatch("stories/updateTabs");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_stories-block";
@import "~@/assets/styles/components/_tabs";
@import "~@/assets/styles/components/_votes";
@import "~@/assets/styles/components/_validation";
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_stories";
</style>
